import React from 'react';
import './AboutUs.css';

import { Banner, PageTitle } from '../../../components';
import { About, Testimonials, Counter, WhyUs, Team, Services, Process, Clients } from '../../../sections';



const AboutUs = () => {
  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About /> {/* About section */}
        <Counter /> {/* Counter section */}
        <Services /> {/* Services section */}
        <WhyUs /> {/* Why Us section */}
        <Process /> {/* Process section */}
        <Testimonials /> {/* Testimonials section */}
        <Team /> {/* Team section */}
        <Banner/> {/* Banner section */}
        <Clients /> {/* Clients Section */}

      </section>

    </>
  );
}

export default AboutUs;